import { useCallback } from 'react'
import CryptoJS from 'crypto-js'

const useEncryptAES = () => {
  const encryptAES = useCallback((data: string): string => {
    const key = CryptoJS.SHA256(String(process.env.NEXT_PUBLIC_SECRET_PARAM)) // menghasilkan 32-byte key
    const iv = CryptoJS.lib.WordArray.random(16)

    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })

    const combined = iv.concat(encrypted.ciphertext)
    return CryptoJS.enc.Base64.stringify(combined)
  }, [])

  return { encryptAES }
}

export default useEncryptAES
